export default "__VITE_ASSET__CkCgeLVN__"